<template lang='pug'>
highcharts(:options="chartConfig")
</template>

<script>

export default {
  props: ['data', 'title'],
  data() {
    return {
      chartData: null
    }
  },
  methods: {
    parseJSON() {
      try {
        this.chartData = JSON.parse(this.data)
      } catch (e) {
        this.chartData = this.data
      }
    }
  },
  computed: {
    chartConfig() {
      return {
        series: [{
          name: 'Durchschnitt aller Firmen',
          color: '#9FBD30',
          data: this.chartData.map(i =>
            ({
              y: Math.round(i[1].average * 100),
              key: i[0]
            }
          ))
        },
        {
          name: 'Priorität der Umsetzung aller Firmen',
          color: '#337ab7',
          data: this.chartData.map(i =>
            ({
              y: Math.round(i[1].soll_average * 100),
              key: i[0]
            }
          ))
        }],
        title: {
          text: this.title
        },
        chart: {
          polar: true,
          type: 'line'
        },
        credits: {
          enabled: false
        },
        pane: {
          startAngle: -50
        },
        plotOptions: {
          line: {
            lineWidth: 4,
            marker: { enabled: false }
          }
        },
        legend: {
          enabled: false
        },
        xAxis: {
          categories: ["Nachvollziehbar", "Vertrauen", "Vision", "Prozesse", "Anerkennung", "Förderung", "Nachhaltigkeit"],
          tickmarkPlacement: 'on',
          lineWidth: 0
        },
        yAxis: {
          labels: {
            enabled: false,
            format: "{value}%",
            step: 1
          },
          maxPadding: 0,
          minPadding: 0,
          min: 0,
          max: 100,
          endOnTick: false,
          lineWidth: 0,
          tickInterval: 25,
        },
        tooltip: {
          shared: true,
          pointFormat: '{point.title} <span style="color:{series.color}">{series.name}: <b>{point.y:,.1f}</b><br/>'
        },
      }
    }
  },
  created() {
    this.parseJSON()
  }
}
</script>

<style scoped>

</style>
